export enum SaasEscrowRequestChangesRoutesEnum {
  Agreement = 'agreement',
  Beneficiary = 'beneficiary',
  Depositor = 'depositor',
  Technical = 'technical',
  Deposits = 'deposits',
}
